import { IApplicationState } from '../../types/redux';
import { ISort } from '../../types/sort';
import { getIsQuestionTab } from '../tabs';
import { QUESTION_TAB_EXCLUDED_SORT } from '../../constants/tabs';

export const getSortOptions = (state: IApplicationState): ISort[] => {
  const isQuestionTab = getIsQuestionTab(state);

  if (isQuestionTab) {
    return state.sort.filter(sort => !QUESTION_TAB_EXCLUDED_SORT.includes(sort.type));
  }

  return state.sort;
};
